<template>
  <div
    v-if="chart"
    class="the-tests-completed-chart"
    data-help-title="Simulierte Prüfungen"
    data-help="Diese Grafik zeigt dir an wieviele Prüfungen du an veschiedenen Tagen simuliert hast."
  >
    <GChart
      v-if="chart.length > 1"
      type="ColumnChart"
      :data="chart"
      :options="chartOptions"
    />
    <div v-else class="message">
      Simuliere Prüfungen um diesen Bereich zu aktivieren
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GChart } from "vue-google-charts";

export default {
  name: "TheTestsCompletedChart",
  components: { GChart },
  data() {
    return {
      chartOptions: {
        title: "Prüfungen bestanden",
        titleTextStyle: {
          color: "#ffffff",
          fontSize: 16,
        },
        width: "95%",
        chartArea: {
          left: 5,
          width: "95%",
        },
        isStacked: true,
        legend: {
          position: "top",
          textStyle: { color: "#ffffff" },
          alignment: "end",
        },
        colors: ["rgb(57, 158, 139)", "#ffffff"],
        hAxis: {
          baseline: 0,
          baselineColor: "#ffffff",
          gridlineColor: "#ffffff",
          minorGridlines: { color: "#ffffff" },
          textStyle: { color: "#ffffff" },
        },
        vAxis: {
          baseline: 0,
          baselineColor: "#ffffff",
          gridlineColor: "#ffffff",
          minorGridlines: { color: "#ffffff" },
          textStyle: { color: "#ffffff" },
          minValue: 0,
        },
        bar: {
          groupWidth: 2,
        },
        annotations: {
          fontName: "monospace",
          stem: {
            length: 0,
          },
          boxStyle: {
            stroke: "#389e8b",
            strokeWidth: 2,
            width: 10,
            color: "#ffffff",
            backgroundColor: "#ffffff",
            gradient: {
              // Start color for gradient.
              color1: "#ffffff",
              // Finish color for gradient.
              color2: "#ffffff",
              // Where on the boundary to start and
              // end the color1/color2 gradient,
              // relative to the upper left corner
              // of the boundary.
              x1: "0%",
              y1: "0%",
              x2: "100%",
              y2: "100%",
              // If true, the boundary for x1,
              // y1, x2, and y2 is the box. If
              // false, it's the entire chart.
              useObjectBoundingBoxUnits: true,
            },
          },
          alwaysOutside: true,
          textStyle: {
            color: "#ffffff",
            fontSize: 10,
            opacity: 0,
          },
        },
        backgroundColor: "rgb(50, 64, 80)",
      },
    };
  },
  computed: {
    chart() {
      if (this.me && this.me.test_data) {
        let data = this.me.test_data.map((d) => {
          let parts = d.date.split("-");
          let displayDate = parts[2] + "." + parts[1];
          return [displayDate, parseInt(d.count, 10), "*"];
        });
        return [
          ["Datum", "Prüfungen", { type: "string", role: "annotation" }],
          ...data,
        ];
      }
      return [];
    },
    ...mapGetters(["me"]),
  },
};
</script>

<style lang="scss" scoped>
.the-tests-completed-chart {
  background: $blue;
  border-bottom: 5px solid $blue;
  padding: 10px;

  .message {
    color: #ffffff;
    padding: 20px;
    text-align: center;
  }
}
</style>
